var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reports"},[_c('dl',[_c('dt',[_c('a',{attrs:{"href":"#"}},[_vm._v("Export Study Selection to Excel")])]),_c('dt',[_c('a',{attrs:{"href":"#"}},[_vm._v("Export Data Extraction to Excel")])]),_c('dt',[_c('a',{attrs:{"href":"#"}},[_vm._v("Tag Report")])])])])
}]

export { render, staticRenderFns }